import React from 'react';
import { ButtonWithIcon } from '@els/els-react--button';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import HoverTooltip from '@Components/HoverTooltip';
import { withRouter } from 'react-router-dom';

function History() {
  const handleHelpClick = (e) => {
    history.push(paths.HISTORY_RECENT);
    e.stopPropagation();
  };

  return (
    <li className="u-els-padding-left-1o2 u-els-padding-bottom-1o8 u-els-display-none@tablet">
      <HoverTooltip id="history-tooltip" tooltip="History" tooltipPlace="bottom-end" theme="simple">
        <ButtonWithIcon
          data-e2e="header-history"
          type="borderless"
          iconOnly
          sprite="Clockwise"
          onClick={handleHelpClick}
          active={history.location.pathname.indexOf('history') >= 0}
          a11y={{ name: 'history' }}
          id="history-icon">
          History
        </ButtonWithIcon>
      </HoverTooltip>
    </li>
  );
}

export default withRouter(History);
